/**
 * Whether a project row or map card should show CO₂ and cost per GFA.
 * Both zeros are an empty project, which hides the metrics instead of rendering "0".
 */
export const shouldShowProjectResultMetrics = (
  co2ePerGFA: number,
  costPerGFA: number,
): boolean => co2ePerGFA !== 0 || costPerGFA !== 0;
